import { render, staticRenderFns } from "./eval-referral.vue?vue&type=template&id=0c38a7f0&scoped=true&"
import script from "./eval-referral.vue?vue&type=script&lang=js&"
export * from "./eval-referral.vue?vue&type=script&lang=js&"
import style0 from "./eval-referral.vue?vue&type=style&index=0&id=0c38a7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38a7f0",
  null
  
)

export default component.exports